import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withHandlers from "recompose/withHandlers";
import get from "lodash/get";
import ProductHeroII from "./ProductHeroII";
import withCountry from "../../hocs/withCountry";
import withProduct from "../../hocs/withProduct";
import withGlobalContent from "../../hocs/withGlobalContent";
import formatPrismicData from "../../hocs/formatPrismicData";
import scrollTo from "../../utils/scrollTo";
import { withModel } from "../../data-providers/model";
import { replaceTextWithValues } from "src/common/utils/text-replace";

const enhance = compose(
  withModel,
  withCountry,
  formatPrismicData,
  withProduct,
  withGlobalContent,
  withProps((props) => {
    const otherSkusForTrustPilotReviews = get(
      props,
      "model.prismicProduct.main.matchingSkusForTrustpilot",
      []
    );

    const newProps = {
      productRatingText: replaceTextWithValues(props.productRatingText, {
        rating: props.productRating,
      }),
      trustPilotSkus: [props.productId]
        .concat(otherSkusForTrustPilotReviews)
        .join(","),
      productAvatarCreation: props.model.productAvatarCreation,
    };

    if (props.product) {
      newProps.price = props.product.lowestPrice;
    }

    return newProps;
  }),
  withHandlers({
    handleCtaClick: (props) => (e) => {},
    handleReviewCtaClick: (props) => (e) => {
      e.preventDefault();
      scrollTo(props.productReviewLinkHref);
    },
  })
);

export default enhance(ProductHeroII);
